@if (sentTo(); as email) {
  <app-auth-window subtitle="auth.subtitle_sent">
    <div class="cmc-auth-result">
      <span class="cmc-auth-result__icon" aria-hidden="true"><mat-icon>mark_email_read</mat-icon></span>
      <p class="cmc-auth-text" role="status">
        {{ 'auth.sent_text' | translate: { email: email, minutes: settings()?.resetLinkMinutes ?? 30 } }}
      </p>
    </div>
    <a class="cmc-auth-button cmc-auth-button--secondary cmc-auth-button--submit" routerLink="/auth/login">
      {{ 'auth.back_to_login' | translate }}
    </a>
  </app-auth-window>
} @else {
  <app-auth-window subtitle="auth.subtitle_forgot">
    <p class="cmc-auth-text">{{ 'auth.forgot_text' | translate }}</p>

    @if (error(); as message) {
      <div class="cmc-auth-alert" role="alert">
        <mat-icon aria-hidden="true">error</mat-icon>
        <span>{{ message }}</span>
      </div>
    }

    <form class="cmc-auth-form" [formGroup]="form" (ngSubmit)="send()" novalidate>
      <div class="cmc-auth-field" [class.is-invalid]="invalid">
        <label class="cmc-auth-field__label" for="forgotEmail">{{ 'auth.email' | translate }}</label>
        <div class="cmc-auth-field__control">
          <mat-icon aria-hidden="true">mail</mat-icon>
          <input id="forgotEmail" type="email" formControlName="email" autocomplete="email"
            [attr.aria-invalid]="invalid">
        </div>
        @if (invalid) {
          <span class="cmc-auth-field__error">{{ 'auth.error_email' | translate }}</span>
        }
      </div>

      <button type="submit" class="cmc-auth-button cmc-auth-button--submit" [disabled]="submitting()"
        [attr.aria-busy]="submitting()">
        {{ 'auth.send_link' | translate }}
        @if (submitting()) {
          <mat-icon aria-hidden="true">progress_activity</mat-icon>
        }
      </button>
      <a class="cmc-auth-link cmc-auth-back" routerLink="/auth/login">← {{ 'auth.back_to_login' | translate }}</a>
    </form>
  </app-auth-window>
}
